module.exports = __webpack_public_path__ + "static/media/layersInactive.808e955c.png";